/*───────────────────────────────────────────────────────────────
 📄 File: hooks/sipPhone/sipSdpModifiers.ts
 🧩 Description:
    SDP modifier functions for hold/unhold operations.
    Pure functions compatible with SIP.js sessionDescriptionHandlerModifiers.
    Extracted from useSipPhone.ts.
────────────────────────────────────────────────────────────────*/

/** Modifies SDP to put media on hold (sendonly direction). */
export function sdpHoldModifier(description: RTCSessionDescriptionInit): Promise<RTCSessionDescriptionInit> {
    if (description.sdp) {
        description.sdp = description.sdp.replace(/a=sendrecv/g, 'a=sendonly');
    }
    return Promise.resolve(description);
}

/** Modifies SDP to resume media from hold (sendrecv direction). */
export function sdpUnholdModifier(description: RTCSessionDescriptionInit): Promise<RTCSessionDescriptionInit> {
    if (description.sdp) {
        description.sdp = description.sdp
            .replace(/a=sendonly/g, 'a=sendrecv')
            .replace(/a=recvonly/g, 'a=sendrecv')
            .replace(/a=inactive/g, 'a=sendrecv');
    }
    return Promise.resolve(description);
}

/** SIP.js sessionDescriptionHandlerModifiers arrays for reuse. */
export const HOLD_MODIFIERS = [sdpHoldModifier];
export const UNHOLD_MODIFIERS = [sdpUnholdModifier];
